'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _ComponentWithUniqueIds = require('../mixins/ComponentWithUniqueIds');

var _ComponentWithUniqueIds2 = _interopRequireDefault(_ComponentWithUniqueIds);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UIBadge = require('./UIBadge');

var _UIBadge2 = _interopRequireDefault(_UIBadge);

var _times = require('HubStyleTokens/times');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER_ANIMATION_TIMEOUT = parseInt(_times.NOTIFICATION_BADGE_ENTER_ANIMATION_TIMING, 10);
var APPEAR_ANIMATION_TIMEOUT = parseInt(_times.NOTIFICATION_BADGE_APPEAR_ANIMATION_TIMING, 10);
var LEAVE_ANIMATION_TIMEOUT = parseInt(_times.NOTIFICATION_BADGE_LEAVE_ANIMATION_TIMING, 10);

var BADGE_SIZE = {
  default: 'count',
  small: 'dot'
};

var BADGE_PLACEMENT = {
  outset: null,
  inline: 'private-notification__badge--inline',
  inset: 'private-notification__badge--inset'
};

var transitionName = { leave: 'private-notification__badge-leave' };

var UINotificationBadge = _react2.default.createClass({
  displayName: 'UINotificationBadge',

  mixins: [_ComponentWithUniqueIds2.default],

  propTypes: {
    badgeClassName: _react.PropTypes.string,
    badgeDescription: _react.PropTypes.string,
    badgeLabel: _react.PropTypes.node,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    placement: _react.PropTypes.oneOf(Object.keys(BADGE_PLACEMENT)),
    size: _react.PropTypes.oneOf(Object.keys(BADGE_SIZE)),
    showBadge: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      placement: 'outset',
      size: 'default',
      showBadge: true
    };
  },
  getClassName: function getClassName(className) {
    return (0, _classNames2.default)('private-notification__wrapper', className);
  },
  renderNotification: function renderNotification(descriptionId) {
    var _props = this.props,
        badgeClassName = _props.badgeClassName,
        badgeDescription = _props.badgeDescription,
        badgeLabel = _props.badgeLabel,
        placement = _props.placement,
        size = _props.size;


    if (!badgeDescription) {
      _devLogger2.default.warn({
        message: 'UINotificationBadge: Please include a meaningful descriptive ' + 'message through the badgeDescription prop for what the badge represents — ' + 'for example, with badgeLabel="10" and badgeDescription="new notifications", ' + 'assistive technology will report "10 new notifications".',
        key: 'UINotificationBadge: missing badgeDescription'
      });
    }

    return _react2.default.createElement(
      _UIBadge2.default,
      {
        className: (0, _classNames2.default)('private-notification__badge', BADGE_PLACEMENT[placement], badgeClassName),
        id: descriptionId,
        use: BADGE_SIZE[size],
        key: badgeLabel
      },
      badgeLabel,
      _react2.default.createElement(
        'span',
        { className: 'sr-only' },
        badgeDescription
      )
    );
  },
  renderBadge: function renderBadge(descriptionId) {
    return _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      {
        transitionName: 'private-notification__badge',
        transitionAppear: true,
        transitionEnter: true,
        transitionLeave: false,
        transitionAppearTimeout: APPEAR_ANIMATION_TIMEOUT,
        transitionEnterTimeout: ENTER_ANIMATION_TIMEOUT
      },
      this.renderNotification(descriptionId)
    );
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        className = _props2.className,
        showBadge = _props2.showBadge;


    var descriptionId = this.getUniqueId('badged-item');

    return _react2.default.createElement(
      'div',
      { className: this.getClassName(className) },
      (0, _react.cloneElement)(children, {
        'aria-describedby': showBadge ? descriptionId : undefined
      }),
      _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: transitionName,
          transitionLeave: true,
          transitionEnter: false,
          transitionLeaveTimeout: LEAVE_ANIMATION_TIMEOUT
        },
        showBadge ? this.renderBadge(descriptionId) : null
      )
    );
  }
});

exports.default = UINotificationBadge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/badge/UINotificationBadge.js
// module id = 514
// module chunks = 2 3